module.exports = __webpack_public_path__ + "img/colaborador(4).49a4a893.png";